import React, { FC, useState, useEffect } from 'react';
import AuthLayout from 'components/AuthLayout';
import AppLoading from 'components/AppLoading';
import { useTranslation } from 'react-i18next';
import API from 'core/Api';
import { useHistory } from 'react-router-dom';
import { IDropdownResponse, IGroupOption } from './types';
import CandidateApplicationForm from './components/CandidateApplicationForm';

const CandidateApplicationScreen: FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [groupOptions, setGroupOptions] = useState<IGroupOption[]>([]);
  const [isOptionsLoading, setIsOptionsLoading] = useState(true);
  const [companyName, setCompanyName] = useState<string>('');
  const [companyTos, setCompanyTos] = useState<string>('');
  const [isMultilingual, setIsMultilingual] = useState<boolean>(false);

  useEffect(() => {
    API.get('employee-candidates/dropdown-options')
      .then((res: { data: IDropdownResponse }) => {
        const groups = res.data.bg?.groups ?? res.data.en?.groups;
        const companyNameCurr = res.data.bg?.client?.company_name ?? res.data.en?.client?.company_name;
        const companyTosCurr = res.data.bg?.client?.tos ?? res.data.en?.client?.tos;
        const isMultilingualCurr =
          (res.data.bg?.client?.is_multilingual ?? res.data.en?.client?.is_multilingual) || false;
        if (groups) {
          setGroupOptions(groups);
        }
        setIsOptionsLoading(false);
        setCompanyName(companyNameCurr || '');
        setCompanyTos(companyTosCurr || '');
        setIsMultilingual(isMultilingualCurr);
      })
      .catch(err => {
        if (err.status === 422) {
          history.push('/404');
          return;
        }
        setIsOptionsLoading(false);
      });
  }, []);

  if (isOptionsLoading) {
    return <AppLoading />;
  }

  return (
    <AuthLayout title={t('candidateApplication.title')}>
      <CandidateApplicationForm
        groupOptions={groupOptions}
        companyName={companyName}
        companyTos={companyTos}
        isMultilingual={isMultilingual}
      />
    </AuthLayout>
  );
};

export default CandidateApplicationScreen;
